module.exports = __webpack_public_path__ + "static/img/cljg.33e7a36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cljg.png
// module id = B46W
// module chunks = 90